<template>

    <div class="addresses">
        <h2>{{ lang('all.mijn_adressen') }}</h2>
        <p>{{ lang('all.adressen_kunnen_binnen_uw_account_opgeslagen_worde') }}</p>
        <div class="row">
            <div class="col-6">
                <header>
                    <h3>{{ lang('all.standaard_factuuradres') }}</h3>
                </header>
                <address v-if="billingaddress === null">
                    {{ lang('all.je_hebt_dit_type_adres_nog_niet_ingesteld') }}
                </address>
                <address v-else>
                    <span v-html="formatAddr(billingaddress.data)"></span>
                    <span>
                        <inertia-link
                            :href="route('auth.myaccount.details.index')"
                            class="address-action-link"
                        >
                            <i class="mdi mdi-pencil"></i>
                            {{ lang('all.adres_wijzigen') }}
                        </inertia-link>
                    </span>
                </address>
            </div>
            <div class="col-6">
                <header>
                    <h3>{{ lang('all.standaard_verzendadres') }}</h3>
                </header>
                <address v-if="shippingaddress === null">
                    {{ lang('all.je_hebt_dit_type_adres_nog_niet_ingesteld') }}
                </address>
                <address v-else>
                    <span v-html="formatAddr(shippingaddress.data)"></span>
                    <span>
                        <inertia-link
                            :href="route('auth.myaccount.addresses.edit', {uuid: shippingaddress.data.uuid})"
                            class="address-action-link"
                        >
                            <i class="mdi mdi-pencil"></i>
                            {{ lang('all.adres_wijzigen') }}
                        </inertia-link>
                    </span>
                </address>
            </div>
        </div>

        <header>
            <h3>{{ lang('all.mijn_adressen') }}</h3>
        </header>

        <div class="row">
            <div
                v-if="addresses.data.length === 0"
                class="col-6"
            >
                <address>
                    {{ lang('all.je_hebt_nog_geen_adressen_ingesteld') }}
                </address>
            </div>
            <div
                v-for="address in addresses.data"
                class="col-6"
            >
                <address>
                    <span v-html="formatAddr(address)"></span>
                    <span>
                        <inertia-link
                            v-if="!isShippingAddress(address)"
                            :href="route('auth.myaccount.addresses.shipping', {uuid: address.uuid})"
                            class="address-action-link"
                        >
                            <i class="mdi mdi-arrow-right"></i>
                            {{ lang('all.instellen_als_standaard_verzendadres') }}
                        </inertia-link>
                        <inertia-link
                            :href="route('auth.myaccount.addresses.edit', {uuid: address.uuid})"
                            class="address-action-link"
                        >
                            <i class="mdi mdi-pencil"></i>
                            {{ lang('all.adres_wijzigen') }}
                        </inertia-link>
                        <inertia-link
                            v-if="canDelete(address)"
                            :href="route('auth.myaccount.addresses.destroy', {uuid: address.uuid})"
                            class="address-action-link"
                        >
                            <i class="mdi mdi-delete"></i>
                            {{ lang('all.adres_verwijderen') }}
                        </inertia-link>
                    </span>
                </address>
            </div>
            <div class="col-6">
                <address>
                    <inertia-link
                        :href="route('auth.myaccount.addresses.create')"
                        style="display:block;"
                    >
                        <i class="mdi mdi-plus"></i>
                        {{ lang('all.nieuw_adres_toevoegen') }}
                    </inertia-link>
                </address>
            </div>
        </div>
    </div>

</template>

<script>

import MyAccountLayout from "../../../../Shared/Auth/MyAccount/Layout";
import FormatAddress from "../../../../Libraries/FormatAddress";

export default {

    layout:MyAccountLayout,

    metaInfo: {
        title: 'Mijn adressen'
    },

    methods: {
        canDelete(address) {
            return false === this.isShippingAddress(address);
        },

        isShippingAddress(address) {
            if (this.shippingaddress === null) {
                return false;
            }

            return this.shippingaddress.data.uuid === address.uuid;
        },

        formatAddr(address) {
            return FormatAddress(address);
        },
    },

    name:'AuthMyAccountAddressesIndex',

    props: {
        addresses: {
            required:true,
        },
        billingaddress: {
            required:true,
        },
        shippingaddress: {
            required:true,
        },
    }

}

</script>

<style lang="scss">

span.address-actions {
    display:block;
    margin-top:20px;
}

span.address-actions > .address-action-link {
    display:block;
}

</style>
